function OffsetsIcon() {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      focusable={false}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C5.37258 0 0 5.37258 0 12V44C0 50.6274 5.37258 56 12 56H44C50.6274 56 56 50.6274 56 44V12C56 5.37258 50.6274 0 44 0H12ZM16.3909 15.4776L21.8 29.0003L26.5186 15.5187C26.8239 14.6464 28.0477 14.6195 28.3909 15.4776L33.8 29.0003L38.5186 15.5187C38.8239 14.6464 40.0477 14.6195 40.3909 15.4776L47.9029 34.2575C48.4284 35.5713 47.4609 37.0003 46.0459 37.0003H42V43C42 43.5523 41.5523 44 41 44H39C38.4477 44 38 43.5523 38 43V37.0003H34.0459H33.819H30V43C30 43.5523 29.5523 44 29 44H27C26.4477 44 26 43.5523 26 43V37.0003H22.0459H21.819H18V43C18 43.5523 17.5523 44 17 44H15C14.4477 44 14 43.5523 14 43V37.0003H9.81896C8.44126 37.0003 7.47612 35.64 7.93124 34.3396L14.5186 15.5187C14.8239 14.6464 16.0477 14.6195 16.3909 15.4776Z"
      />
    </svg>
  );
}
export default OffsetsIcon;
